// extracted by mini-css-extract-plugin
module.exports = {"Parameters":"Parameters_Parameters__Kc_6c"};